import { render, staticRenderFns } from "./pos-last-contact-access.vue?vue&type=template&id=740ea938&scoped=true&"
import script from "./pos-last-contact-access.vue?vue&type=script&lang=ts&"
export * from "./pos-last-contact-access.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ea938",
  null
  
)

export default component.exports